import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TaskAlt from '@mui/icons-material/TaskAlt';
import HourglassBottom from '@mui/icons-material/HourglassBottom';
import InformationStack from '../stacks/InformationStack';
import { SUCCESS_STACK_CLASS_NAME, PENDING_STACK_CLASS_NAME } from '../../theme/constants/stack';
import useIsMobile from '../../hooks/useIsMobile';

const CardHeader = ({ status, primaryText }) => {
  const isMobile = useIsMobile();
  return (
    <Stack direction="row" display="flex" justifyContent="space-between" alignItems="center" px={3} pt={2} pb={1}>
      <Typography variant={isMobile ? 'small_3' : 'medium_2'} color="gray.A600" fontWeight={600} mr={1}>
        {primaryText}
      </Typography>
      {status !== null && (
      <InformationStack
        text={status ? 'Listo' : 'Pendiente'}
        className={status ? SUCCESS_STACK_CLASS_NAME : PENDING_STACK_CLASS_NAME}
        variant={isMobile ? 'small_1' : 'small_3'}
        fontWeight={500}
        IconComponent={status ? <TaskAlt fontSize="small" /> : <HourglassBottom fontSize="small" />}
      />
      )}
    </Stack>
  );
};

CardHeader.propTypes = {
  status: PropTypes.bool,
  primaryText: PropTypes.string.isRequired,
};

CardHeader.defaultProps = {
  status: null,
};

export default CardHeader;
